/* import __COLOCATED_TEMPLATE__ from './group-delete.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./group-delete.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());